import {
  writeToLocalStorage,
  readFromLocalStorage,
} from '@sentecacommerce-theme/lib'

export const setHeight = ({
  ref,
  page,
  height,
}: {
  ref?: HTMLDivElement | any
  page: string
  height?: number
}) => {
  let totalHeight = height ?? 0

  if (!height) {
    if (ref?.current?.children) {
      Array.from(ref.current.children)?.forEach((child: any) => {
        totalHeight +=
          parseInt(window.getComputedStyle(child).marginBottom) +
          child?.offsetHeight
      })
    }
  }

  writeToLocalStorage(`toggle-${page}-height`, totalHeight)
}

export const getHeight = (page: string) => {
  return readFromLocalStorage(`toggle-${page}-height`)
}
